import { Type } from "@angular/core";

export enum ActionColor {
  PRIMARY = '#4e80ee',
  SECONDARY = '#6c757d',
  SUCCESS = '#198754',
  INFO = '#5bc0de',
  WARNING = '#f0ad4e',
  DANGER = '#d9534f',
  HELP = '#9c27b0',
  FLAT = 'flat',
  LIGHT = '#e9ecef',
  DARK = '#343a40'
}

export interface TableAction {
  label?: string;
  icon: string;
  action: string;
  component?: Type<any>;
}

export interface CheckBoxAction {
  label?: string;
  icon?: string;
  color?: ActionColor;
  action: string;
  component?: Type<any>;
}